"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const common_1 = require("../common");
const ledger_1 = require("./parse/ledger");
function getLedger(options = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        common_1.validate.getLedger({ options });
        const response = yield this.request('ledger', {
            ledger_hash: options.ledgerHash,
            ledger_index: options.ledgerVersion || 'validated',
            expand: options.includeAllData,
            transactions: options.includeTransactions,
            accounts: options.includeState
        });
        return ledger_1.parseLedger(response.ledger);
    });
}
exports.default = getLedger;
//# sourceMappingURL=ledger.js.map